module.exports = __webpack_public_path__ + "img/Service_content_4.e0aa376d.png";